import {
    CrudSection
} from "../../../crud";
import {
    _WorkflowController
} from "../";

export class WorkflowStep extends CrudSection {
    steps = [];
    totalSteps = 0 
    constructor(ctrl = new _WorkflowController()) {
        super(ctrl);
    }

    addWorkflowAction(module, mappedStep) {
        let newStep = module.createStep();
        newStep.rank = mappedStep.rank
        this.ctrl.app.$refs.moduleSelector.show("onModuleSelected",
            newStep, module.systemCode, this);

    }

    addWorkflowStep() {
        let last = this.steps[this.steps.length - 1]
        let rank = 0
        if (last != null && last != undefined) {
            rank = last.rank
        }
        this.steps.push({
            rank: rank + 1,
            steps: []
        })
    }

    assingWorkflowModule(step) {
        this.ctrl.app.$refs.moduleSelector.show("onModuleSelected", step, step.systemCode, this);

    }

    async onModuleSelected(module, step) {
        if (module != null) {
            step.moduleRefId = module.id;
            if (step.id > 0) {
              await  this.updateStep(step, module);
            } else {
                await this.addStep(step);
            }
        }
    }
    async deleteStep(item) {
        this.ctrl.app.$refs.confirmationDialog.showDialog({
            title: `Delete ${this.ctrl.getCurrentSystemModule().name}`,
            message: `Are you sure you wish to delete this ${item.systemCode}?`,
            callback: "onStepDeleted",
            callbackData: item,
            controller: "workflow"
        });
    }


    canDelete(step) {
        let allowedModules = this.ctrl.getCurrentSystemModule().getAllowedModules()
        let currentModule = allowedModules.find(x => x.systemCode == step.systemCode)
        if (currentModule != undefined) {
            return currentModule.canDelete
        } else {
            return true
        }
    }

    addMenuItems() {
        let retVal = []
        let allowedModules = this.ctrl.getCurrentSystemModule().getAllowedModules()
        allowedModules.forEach(element => {
            if (element.canAdd) {
                retVal.push(element)
            }
        });
        return retVal
    }



    async updateStep(step) {
        let response = await this.ctrl.execute(this.ctrl.actions.updateWorkflowStep, step, `?id=${step.id}`)
        if (response.success) {
            this.ctrl.getWorkflowSteps(this.ctrl.app.$route.params.id)

            this.ctrl.app.$refs.snackbarAlert.show({
                colour: "success",
                text: `${this.ctrl.currentSystemModule.systemCode} step successfully updated`
            })
        }
    }

    async addStep(step) {
        step.workflowId = this.ctrl.app.$route.params.id
        let response = await this.ctrl.execute(this.ctrl.actions.createWorkflowStep, step)
        if (response.success) {
            this.ctrl.getWorkflowSteps(this.ctrl.app.$route.params.id)
            this.ctrl.app.$refs.snackbarAlert.show({
                colour: "success",
                text: `${this.ctrl.currentSystemModule.systemCode} step successfully added`
            })
        }
    }
}